import { useDispatch } from 'react-redux';
import { Skeleton } from 'antd';
import moment from 'moment';

import { Paths } from 'constants/index';

import { Drawers } from 'app/types/drawer';
import { useGetProjectByIdQuery, useUpdateProjectMutation } from 'app/services/projects';
import { sitesApi, tags } from 'app/services/sites';

import ProjectForm from './ProjectForm';

import { formatMomentToDate } from 'utils/datetime';

const EditProject = ({ projectId } : { projectId : number }) => {
  const { data: project, isLoading } = useGetProjectByIdQuery(projectId);

  const [ updateProject, meta ] = useUpdateProjectMutation();

  const dispatch = useDispatch();

  const handleSubmit = async (values: any) => {
    const updateData = {
      ...project,
      ...values,
      Start: formatMomentToDate(values.Start)
    };

    await updateProject(updateData);

    dispatch(sitesApi.util.invalidateTags([ tags.PROJECTLIST ]));
  };

  if (isLoading || !project) return <Skeleton active />;

  return <ProjectForm
    formId={Drawers.EDIT_PROJECT}
    handleSubmit={handleSubmit}
    meta={meta}
    redirectTo={Paths.PROJECTS_VIEW}
    initialValues={{ ...project, Start: moment(project.Start) }}
    countryId={project.CountryId}
  />;
};

export default EditProject;
